var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _radialGradient, _path5, _radialGradient2, _path6, _radialGradient3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Person(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "57x9VResF02c1zXeKKCeoa",
    x1: 20.766,
    x2: 25.05,
    y1: 30.008,
    y2: 44.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeoa)",
    d: "M24,30.571c-8.837,0-16,4.921-16,10.286V42c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2 v-1.143C40,35.492,32.837,30.571,24,30.571z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M29,32c0,1.897-2,4-5,4s-5-2.103-5-4c0-2.637,0-7.035,0-7.035h10C29,24.965,29,29.363,29,32z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "57x9VResF02c1zXeKKCeob",
    x1: 32.917,
    x2: 34.251,
    y1: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeob)",
    d: "M32.916,18h-0.527v4h0.703c0.515,0,0.954-0.312,1.041-0.74l0.344-1.703 C34.642,18.743,33.897,18,32.916,18z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "57x9VResF02c1zXeKKCeoc",
    x1: -615.083,
    x2: -613.749,
    y1: 20,
    y2: 20,
    gradientTransform: "matrix(-1 0 0 1 -600 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeoc)",
    d: "M15.084,18h0.527v4h-0.703c-0.515,0-0.954-0.312-1.041-0.74l-0.344-1.703 C13.358,18.743,14.103,18,15.084,18z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "57x9VResF02c1zXeKKCeod",
    cx: 24,
    cy: -9.669,
    r: 12.224,
    gradientTransform: "translate(2.84 27.224) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeod)",
    d: "M24,6.4c-4.441,0-9,0.675-9,10.275c0,0.768,0,5.877,0,6.698C15,26.8,20.4,31,24,31 s9-4.2,9-7.627c0-0.821,0-5.929,0-6.698C33,7.075,28.441,6.4,24,6.4z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "57x9VResF02c1zXeKKCeoe",
    cx: 14.297,
    cy: -23.322,
    r: 28.915,
    gradientTransform: "translate(2.84 27.224) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeoe)",
    d: "M24,5.545c-4.354,0-5,1.636-5,1.636c-1.77,0.261-5,2.854-5,5.818c0,1.654,0.265,2.876,1,7 c0.545-6.545,2.249-9,4-9c1.267,0,2.273,1,5,1c2.303,0,2.875-1,5-1c3,0,4,7.968,4,9c0.601-3.01,1-5.555,1-7 C34,9.57,30.209,5.545,24,5.545z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "57x9VResF02c1zXeKKCeof",
    cx: 21.937,
    cy: -21.386,
    r: 33.398,
    gradientTransform: "matrix(.8431 0 0 .8816 4.07 27.224)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#57x9VResF02c1zXeKKCeof)",
    d: "M24.219,5c-4.164,0-5.216,2.182-5.216,2.182c-0.042,1.159,0.522,2.182,0.522,2.182 S20.285,11,24.625,11C27.245,11,31,9.365,31,5C31,5,30.157,5,24.219,5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Person);
export default __webpack_public_path__ + "static/media/icons8-person.403304caacc6ecdbcc0da2220ce26a4e.svg";
export { ForwardRef as ReactComponent };